import TopNavigationLayout from '../../../layouts/TopNavigationLayout';
import Search from './Search';
export default TopNavigationLayout(Search);
